export enum AvailableLanguage {
    EnGb = 'en-gb',
    EnUs = 'en-us',
    RuRu = 'ru-ru',
    EsEs = 'es-es',
    FrFr = 'fr-fr',
}
